import { SiteDataInputType } from '../../calculator.component';
import { PvgisProductionType } from './pvgis-production-type';
import { ProductionTypeInterface } from './production-type.interface';
import { NrelProductionType } from './nrel-production-type';
import { PvsolProductionType } from './pvsol-production-type';
import { PvsysProductionType } from './pvsys-production-type';

export class ProductionTypeFactory {
  static getProductionTypeInstance(type: SiteDataInputType): ProductionTypeInterface {
    switch (type) {
      case SiteDataInputType.PVGIS:
        return new PvgisProductionType();
      case SiteDataInputType.PVSOL:
        return new PvsolProductionType();
      case SiteDataInputType.PVSYS:
        return new PvsysProductionType();
      case SiteDataInputType.NREL:
        return new NrelProductionType();
      default:
        return new PvgisProductionType();

    }
  }
}
